@for (entryControl of formArray.controls; track entryControl; let i = $index; let first = $first) {
  <sh-advanced-search-row-container
    [i18n]="i18n"
    [id]="'adv-row-' + i"
    [index]="i"
    [label]="i18n.label.title"
    [formGroup]="entryControl"
    [formArrayCount]="formArray.length"
    [options]="fieldDefinitionOptions"
    [profileFields]="profileFields"
    (shouldAddControl)="addControl($event)"
    (shouldRemoveControl)="removeControl($event)"
  ></sh-advanced-search-row-container>
}
